import { toast } from "sonner";
import { api, errMsg, ts } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Btn, Empty, PageHead, Panel, Spinner } from "../components/common";

const TONE = { pending: "bg-amber-50 text-amber-700", approved: "bg-emerald-50 text-emerald-700", rejected: "bg-red-50 text-red-700", revoked: "bg-slate-100 text-slate-600" };

export default function Members() {
  const { data, reload } = useFetch("/members", 30000);
  const act = async (m, action) => {
    try { await api.post(`/members/${m.id}`, { action }); toast.success(`${m.email}: ${{ approve: "approved", reject: "rejected", revoke: "revoked" }[action]}`); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const pending = (data || []).filter((m) => m.status === "pending").length;
  return (
    <div>
      <PageHead title="Members" sub="People who requested the read-only signal dashboard. They never see your Moomoo account, funds, orders or settings." />
      <Panel title={`Requests · ${pending} pending`} testid="members-panel">
        {!data ? <Spinner /> : !data.length ? <Empty>No requests yet. Share the landing page: /welcome</Empty> : (
          <div className="custom-scrollbar overflow-x-auto"><table className="tbl w-full">
            <thead><tr><th>Name</th><th>Email</th><th>Note</th><th>Requested</th><th>Status</th><th /></tr></thead>
            <tbody>{data.map((m) => (
              <tr key={m.id} data-testid={`member-row-${m.id}`}><td>{m.name}</td><td className="mono text-[11px]">{m.email}</td><td className="max-w-xs text-[11px] text-slate-600">{m.note || "—"}</td><td className="mono text-[11px]">{ts(m.created_at)}</td>
                <td><span className={`mono rounded-sm px-1.5 py-0.5 text-[10px] font-bold ${TONE[m.status]}`} data-testid={`member-status-${m.id}`}>{m.status}</span></td>
                <td className="flex gap-1">
                  {m.status !== "approved" && <Btn onClick={() => act(m, "approve")} data-testid={`member-approve-${m.id}`}>Approve</Btn>}
                  {m.status === "pending" && <Btn variant="ghost" onClick={() => act(m, "reject")} data-testid={`member-reject-${m.id}`}>Reject</Btn>}
                  {m.status === "approved" && <Btn variant="ghost" onClick={() => act(m, "revoke")} data-testid={`member-revoke-${m.id}`}>Revoke</Btn>}
                </td></tr>))}
            </tbody></table></div>
        )}
      </Panel>
    </div>
  );
}
